// extracted by mini-css-extract-plugin
export default {"navigation":"navigation__navigation--P6OHQ","list":"navigation__list--tQMWu","mobileNavButton":"navigation__mobileNavButton--KbJ_q"};